// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2CKwg","header":"ClearentDisclaimer_header__m4823","inner":"ClearentDisclaimer_inner__3ha2c"};